<template>
  <div class="cover-image">
    <PdfUploaderModal
      :pdfObject.sync="currentPdf"
      :fileType="fileType"
      :onCloseModal="onCloseUploaderPdfModal"
      v-if="isUploaderPdfModalShowing">
      <template v-slot:header-title>
        <h5>เลือกไฟล์</h5>
      </template>
      <template v-slot:button-submit>
        <span>ยืนยัน</span>
      </template>
    </PdfUploaderModal>
    <div class="cover-image-header">
      <slot
        name="coverPdfHeader"
        :choosePdf="choosePdf" />
    </div>
    <slot
      name="pdfContainer">
    </slot>
  </div>
</template>

<script>
import _ from 'lodash';
import PdfUploaderModal from './PdfUploaderModal.vue';

export default {
  props: {
    pdf: {
      type: Object,
      default: () => {},
    },
    fileType: {
      type: String,
      default: 'pdf',
    },
  },
  components: {
    PdfUploaderModal,
  },
  data() {
    return {
      currentPdf: null,
      isUploaderPdfModalShowing: false,
    };
  },
  created() {
    this.currentPdf = _.cloneDeep(this.pdf);
  },
  watch: {
    currentPdf() {
      this.$emit('update:pdf', this.currentPdf);
      this.onCloseUploaderPdfModal();
    },
  },
  methods: {
    choosePdf() {
      this.onToggleUploaderPdfModal();
    },
    onCloseUploaderPdfModal() {
      this.isUploaderPdfModalShowing = false;
    },
    onToggleUploaderPdfModal() {
      this.isUploaderPdfModalShowing = !this.isUploaderPdfModalShowing;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/variables.scss';

.cover-image {
  // height: 100%;
  // width: 80%;
}
.cover-image-header {
  position: relative;

  display: flex;
  align-items: center;

  .name {
    font-weight: normal;
    color: $body-color;
    font-family: $font-family-CSPrajad;
    font-size: $font-size-base;
    margin-bottom: 0;
  }

  .actions {
    margin-left: auto;

    .btn {
      &:last-child {
        padding-right: 0;
      }
    }
  }
}

</style>
